import React, { useRef } from "react";
import "./Portfolio.css";
import { useNavigate } from "react-router-dom";
import cal from "../../assets/images/snake.png";
import Mchat from "../../assets/images/chatappM.png";
import Social from "../../assets/images/Social.png";
import tour from "../../assets/images/love.png";
import food from "../../assets/images/food.png";
import chat from "../../assets/images/chat.png";
import ml from "../../assets/images/face1.png";
import Pchat from "../../assets/images/pchat.png";
import alumni from "../../assets/images/alumni.png";
import booking from "../../assets/images/booking.png";
import edu from "../../assets/images/edu.png";
import trans from "../../assets/images/trans.png";

const data = [
  {
    id: 1,
    image: food,
    url: "Feed_Forward",
    title: "Feed Forward (Donation App)",
    github: "https://github.com/Mayank-kr-sh/Feed-Forward-App",
    demo: "https://github.com/Mayank-kr-sh/Feed-Forward-App",
  },
  {
    id: 2,
    image: chat,
    url: "Insight_Mate",
    title: "Insight Mate (Chat GPT - AI)",
    github: "https://github.com/Mayank-kr-sh/Hackathon-Insight-Mate",
    demo: "https://github.com/Mayank-kr-sh/Hackathon-Insight-Mate",
  },
  {
    id: 3,
    image: alumni,
    url: "Connect_X",
    title: "Connect - X (Alumni App)",
    github: "https://github.com/Mayank-kr-sh/Connect-X",
    demo: "https://github.com/Mayank-kr-sh/Connect-X",
  },
  {
    id: 4,
    image: Pchat,
    url: "Chat_With_Me",
    title: "Chat With Me (Chat App)",
    github: "https://github.com/Mayank-kr-sh/Flutter_Chat_App",
    demo: "https://github.com/Mayank-kr-sh/Flutter_Chat_App",
  },
  {
    id: 5,
    image: Social,
    url: "Social_Sense",
    title: "Social Sense (Social Media App)",
    github: "https://github.com/Mayank-kr-sh/SocialSense",
    demo: "https://github.com/Mayank-kr-sh/SocialSense",
  },
  {
    id: 6,
    image: Mchat,
    url: "Chat_App",
    title: "ChatApp (MERN Stack)",
    github: "https://github.com/Mayank-kr-sh/Chat_App",
    demo: "https://chatapp-zvez.onrender.com/",
  },
  {
    id: 7,
    image: booking,
    url: "Booking_Website",
    title: "Booking Website (MERN Stack)",
    github: "https://github.com/Mayank-kr-sh/Booking_Website",
    demo: "https://github.com/Mayank-kr-sh/Booking_Website",
  },
  {
    id: 8,
    image: trans,
    url: "Transcribe",
    title: "Transcribe (ML Model)",
    github: "https://github.com/Mayank-kr-sh/TranScribe",
    demo: "https://github.com/Mayank-kr-sh/TranScribe",
  },
  {
    id: 9,
    image: cal,
    url: "Snake_Game",
    title: "Snake Game (C++)",
    github: "https://github.com/Mayank-kr-sh/CPP-Snake-Game-Project",
    demo: "https://github.com/Mayank-kr-sh/CPP-Snake-Game-Project",
  },
  {
    id: 10,
    image: ml,
    url: "Face_Recognition",
    title: "Face Recognition (ML Model)",
    github: "https://github.com/Mayank-kr-sh/Face-Recognition",
    demo: "https://github.com/Mayank-kr-sh/Face-Recognition",
  },
  {
    id: 11,
    image: edu,
    url: "Education_App",
    title: "Education App (MERN Stack)",
    github: "https://github.com/Mayank-kr-sh/Backend_Project",
    demo: "https://github.com/Mayank-kr-sh/Backend_Project",
  },
  {
    id: 12,
    image: tour,
    url: "Tour_Travels",
    title: "Tour & Travels (Love India)",
    github: "https://github.com/Mayank-kr-sh/LoveIndia",
    demo: "https://mayank-kr-sh.github.io/LoveIndia/",
  },
];

const Portfolio = () => {
  const imageRefs = useRef([]);
  const navigate = useNavigate();

  const handleMouseMove = (index, e) => {
    const image = imageRefs.current[index];
    const { left, top, width, height } = image.getBoundingClientRect();

    // Calculate the position of the cursor relative to the image
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height;

    const moveX = (x - 0.5) * 20; // Adjust the speed of movement
    const moveY = (y - 0.5) * 20; // Adjust the speed of movement

    image.style.transform = `translate(${moveX}px, ${moveY}px)`;
  };

  const handleMouseEnter = (index) => {
    const image = imageRefs.current[index];
    image.style.transform = "none"; // Clear the transformation
  };

  const handleMouseLeave = (index) => {
    const image = imageRefs.current[index];
    image.style.transform = ""; // Reset the transformation
  };

  const HandleChange = (url) => {
    navigate(`/portfolio/${url}`);
  };

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo, url }, index) => {
          return (
            <article
              key={id}
              className="portfolio__item"
              onClick={() => HandleChange(url)}
            >
              <div
                className="portfolio__item-image"
                onMouseMove={(e) => handleMouseMove(index, e)}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
                ref={(el) => (imageRefs.current[index] = el)}
              >
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-ctx">
                <a href={github} className="btn" target={id}>
                  GitHub
                </a>
                <a href={demo} className="btn btn-primary" target=" ">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
